import { AlertTriangle } from 'lucide-react';

export function ContactAdminMessage() {
  return (
    <div className="text-center">
      <div className="p-4 mb-4 rounded-lg bg-blue-50">
        <p className="text-sm text-neutral-800">
          To get access, please contact {' '}
          <a href="mailto:max@revi.ai" className="font-medium underline hover:text-blue-900">
            max@revi.ai
          </a>{' '}
          to set up your organization.
        </p>
      </div>

      <button
        onClick={() => (window.location.href = '/auth/login')}
        className="text-sm font-medium cursor-pointer text-neutral-600 hover:underline"
      >
        ← Try a different email
      </button>
    </div>
  );
}
